import FaqItem from '../components/FaqItem';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';

const Faq = () => {
  const faqData = [
    {
      question: "What is DogWifHair?",
      answer: "DogWifHair is a next-generation multi-chain launchpad that allows anyone to create, launch, and grow meme tokens without coding. It integrates bonding curve pricing, auto liquidity locking, and a referral rewards system to create sustainable decentralized micro-economies."
    },
    {
      question: "How does DogWifHair prevent rug pulls?",
      answer: "By automatically burning LP tokens and renouncing contracts when tokens are launched. This removes admin control and ensures liquidity is permanently locked."
    },
    {
      question: "What is bonding curve pricing?",
      answer: "A system where token price increases as more tokens are bought. This ensures fair distribution and prevents manipulation by early buyers."
    },
    {
      question: "How do referral rewards work?",
      answer: "Users earn 0.5% from every trade made by people they refer. Rewards are tracked in real-time with transparent on-chain validation."
    },
    {
      question: "What chains does DogWifHair support?",
      answer: "Initially launching on Ethereum with planned expansion to Polygon and Solana in Phase 2."
    }
  ];

  return (
    <div className="flex flex-col min-h-screen" style={{ background: 'var(--page-bg)' }}>
      <TopBar />
      <div className="container mx-auto px-4 py-8 max-w-3xl mt-16 flex-grow">
        <h1 className="text-3xl font-bold mb-8 text-center" style={{ color: 'var(--text-primary)' }}>
          Frequently Asked Questions
        </h1>
        <div className="faq-list">
          {faqData.map((item, index) => (
            <FaqItem 
              key={index}
              question={item.question}
              answer={item.answer}
            />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Faq;
